/**
 * @file LandingViewModel.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { Subject } from "rxjs";
import { ApiError } from "../../services/models/ApiError";
import { GetUserDetailResponse } from "../../services/models/GetUserDetailResponse";
import ViewModel from "../base/ViewModel";

/**
 * A class definition for LandingViewModel
 */
export class LandingViewModel extends ViewModel {

    onLoadUser = new Subject<GetUserDetailResponse>();
    onLoadUserError = new Subject<ApiError>();

    onUserLogout = new Subject<any>();
    onUserLogoutError = new Subject<ApiError>();    

    constructor() {
        super();
    }

    /**
     * Gets User details
     * @param accessToken string
     */
    async getUserDetails(accessToken: string) {
            try {
                const response = await this.apiService.getMe(accessToken)
                this.onLoadUser.next(response)
            } catch (e) {
                if (e instanceof ApiError) {
                    this.logger.verbose(JSON.stringify(e), LandingViewModel.name);
                }
                this.onLoadUserError.next(e as ApiError)
            }
    }

    /**
     * Logout
     * @param accessToken string
     */
    async logout(accessToken: string) {
        try {
            const response = await this.apiService.logout(accessToken)
            this.onUserLogout.next(response)
        } catch (e) {
            if (e instanceof ApiError) {
                this.logger.verbose(JSON.stringify(e), LandingViewModel.name);
            }
            this.onUserLogoutError.next(e as ApiError)
        }
}    
}